import { CONSENT_STORAGE_KEY, DEFAULT_CONSENT_PREFERENCES } from "../constants";
import { ConsentPreferences, StoredConsent } from "../types";
import { localStorageGetValue } from "../../../shared/hooks/useLocalStorage";

const isStoredConsent = (value: unknown): value is StoredConsent =>
  typeof value === "object" &&
  value !== null &&
  "version" in value &&
  "preferences" in value &&
  typeof value.version === "number";

export const readStoredConsent = (): StoredConsent | undefined => {
  try {
    const parsed = localStorageGetValue(CONSENT_STORAGE_KEY, {}, "local");
    return isStoredConsent(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const getCurrentPreferences = (): ConsentPreferences =>
  readStoredConsent()?.preferences ?? DEFAULT_CONSENT_PREFERENCES;
